var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mb-2",attrs:{"label":"","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-label")]),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }